import React, {  useState } from 'react'
import "./contactme.css"
import img from '../../assets/Images/Img4.png'
import { useForm } from '@formspree/react';



function ContactForm() {
    const [crediantial, setCrediential] = useState("");
    const [status, setStatus] = useState(false);
    const [message, setMessage] = useState("*All filds are required");
    const [state, handleSubmit] = useForm("xnqrajld");
    // eslint-disable-next-line
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const onchange = (e) => {
        setCrediential({ ...crediantial, [e.target.name]: e.target.value });
        if (crediantial?.username.replaceAll(' ', '').length > 0 && crediantial?.message.replaceAll(' ', '').length > 0 && crediantial.email.match(mailformat)) {
            state.submitting = true;
            setStatus(true)
            setMessage("");
        }
    }

    return (
        <div className="contact-section overflow" id="Contact">
            <div className="contact-section2 row container">
                <div className="contactMeRight col-lg-6 col-md-12">
                    <div className="image">
                        <img src={img} alt="" />
                    </div>
                </div>
                <div className="contactMeLeft col-lg-6 col-md-12">
                    <h3 className="sectionIntro">Contact me:</h3>
                    <form
                        onSubmit={handleSubmit}
                        className="contact-form"
                    >
                        <div className="input-box">
                            <input
                                type="text"
                                placeholder='Name'
                                className="contact-form-text"
                                name="username"
                                id='name'
                                value={crediantial.username}
                                onChange={onchange}
                            />
                        </div>
                        <div className="input-box">
                            <input
                                placeholder='Email'
                                type="email"
                                className="contact-form-text"
                                name="email"
                                value={crediantial.email}
                                onChange={onchange}
                            />
                        </div>
                        <div className="input-box">
                            <textarea
                                placeholder='message...'
                                className="contact-form-text"
                                name="message"
                                id='message'
                                value={crediantial.message}
                                onChange={onchange}
                            ></textarea>
                            {state.succeeded ? <p className='thanks_for'>Thanks for Connecting!</p> : ""}
                            {<p className='warning' id='warning'>{message}</p>}
                        </div>

                        <button type="submit" disabled={state.submitting || !status} className='contact-form-btn' id='submit'>
                            <div className="svg-wrapper-1">
                                <div className="svg-wrapper">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                        <path fill="none" d="M0 0h24v24H0z"></path>
                                        <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                                    </svg>
                                </div>
                            </div>
                            <span>Send</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

const ContactMe = () => {
    return (
        <ContactForm />
    )
}

export default ContactMe

